'use client'

import { useEffect } from 'react'

/**
 * Scrolls to the top of the page on mount.
 * Used in template.tsx to ensure scroll resets on navigation,
 * since the async template re-mount can delay Next.js's built-in scroll-to-top.
 */
export default function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return null
}
